import { Check, Minus } from "lucide-react";
import { PERMISSIONS, ROLES, ROLE_DESCRIPTIONS, ROLE_LABELS } from "@/lib/permissions";
import { RoleBadge } from "./TeamBits";

export function RolesMatrix() {
  return (
    <div className="space-y-6" data-testid="roles-matrix">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {ROLES.map((r) => (
          <div key={r} className="rounded-2xl border border-border bg-card p-5" data-testid={`role-card-${r}`}>
            <RoleBadge role={r} />
            <p className="mt-3 text-sm text-muted-foreground">{ROLE_DESCRIPTIONS[r]}</p>
          </div>
        ))}
      </div>
      <div className="overflow-x-auto rounded-2xl border border-border bg-card">
        <table className="w-full min-w-[640px] text-sm">
          <thead>
            <tr className="border-b border-border text-left">
              <th className="px-5 py-3 font-semibold">Permission</th>
              {ROLES.map((r) => <th key={r} className="px-4 py-3 text-center font-semibold">{ROLE_LABELS[r]}</th>)}
            </tr>
          </thead>
          <tbody>
            {PERMISSIONS.map((p) => (
              <tr key={p.key} className="border-b border-border last:border-0">
                <td className="px-5 py-3">{p.label}</td>
                {ROLES.map((r) => (
                  <td key={r} className="px-4 py-3 text-center" data-testid={`perm-${p.key}-${r}`}>
                    {p.roles.includes(r) ? <Check className="mx-auto h-4 w-4 text-emerald-600" /> : <Minus className="mx-auto h-4 w-4 text-muted-foreground/50" />}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
